<template>
  <a :href="buyPageUrl" class="button button--primary">
    {{ $t('calculator.profit-result.cta', {
    cryptoName: cryptoCurrency.name,
  }) }}
  </a>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { i18n as i18nInstance } from "@kano/i18n";
import { ProfitCalculatorCurrency } from "@kano/types/profit-calculator";
import UrlGenerator from '@paybis/frontend-common-lib/src/services/url';

const props = defineProps<{
  cryptoCurrency: ProfitCalculatorCurrency,
}>();

const buyPageUrl = computed(() => {
  const { links } = props.cryptoCurrency;

  if (!links?.buy) {
    return UrlGenerator.generate('/', {}, i18nInstance.locale);
  }

  return UrlGenerator.generate(links.buy, {}, i18nInstance.locale);
});
</script>